import login from './login'

const schema = {
  login,
}

export default schema
